'use client';

import { ArrowScroll } from '@/components/ArrowScroll';
import { IHomeDictionary } from '@/dictionaries/pages/home/types';
import { useNewHeader } from '@/featureFlags/newHeader';
import Image from 'next/image';
import headerMobile from '../../../public/header-mobile2.jpg';

export function Hero({ homeDict }: { homeDict: IHomeDictionary }) {
  const newHeader = useNewHeader();

  if (newHeader) {
    return null;
  }

  return (
    <div className="relative flex flex-col desktop:aspect-video min-h-[110vh] desktop:min-h-[650px] w-full justify-center text-white items-center desktop:max-h-[95svh] -top-[100px]">
      <Image
        src={headerMobile}
        alt="header-mobile"
        fill
        className="absolute object-cover brightness-75"
      />

      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 brightness-[.6] object-cover object-center w-full h-full desktop:aspect-video hidden desktop:block">
        <source
          src="https://villatravellers-prod.s3.eu-west-2.amazonaws.com/uploads/video/Villatravellers_short_1280.webm"
          type="video/webm"
        />
        <source
          src="https://villatravellers-prod.s3.eu-west-2.amazonaws.com/uploads/video/Villatravellers_short_1280.mp4"
          type="video/mp4"
        />
      </video>

      <div className="px-2 desktop:px-28 pb-8 tablet:pb-0 w-full z-[1]">
        <h1 className="font-title text-3xl desktop:text-[40px] text-center pb-4 desktop:pb-10 leading-[1.25] font-semibold">
          {homeDict.bannerTitle}
        </h1>

        <div className="flex flex-col desktop:gap-1">
          {homeDict.bannerSubtitle.map((line, index) => (
            <p
              key={index}
              className="font-averta-light text-base desktop:text-xl text-center">
              {line}
            </p>
          ))}
        </div>

        <ArrowScroll navigateToId="villa-types" />
      </div>
    </div>
  );
}
